module.exports = __webpack_public_path__ + "media/images/flags/af-c987fc777f727d757d8fe49e0a023856.svg";